<template>
  <div class="eventComp_mode_1 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :expandKey="expandKey"
        :expandColumnCallback="expandColumnCallback"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 射箭非对抗类 || 射击 本地数据
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_1',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  ||【 本场数据'localData' || 轮次成绩'roundResult' ||  单项成绩'singleResult' || 团体成绩 'teamResult' || 全能成绩'combinedResult'】,
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_1 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_1',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 34.7,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度
      currModeObj: null,
      renderModeList: [
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['ARC'],
          resultKeyArr: ['result_single', ''],
          isCompetitorTypeArr: ['A'], //射箭 排名赛 只有A，没有T；
          tabTypeArr: ['singleResult'], // 射箭：只有【个人排名赛】
        },
      ],
    }
  },
  // created() {
  //   this.init()
  // },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (
              modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
              modeItem.isCompetitorTypeArr.includes(this.competitorType)
            ) {
              this.currModeObj = modeItem
            }
          })
        }
        console.debug('mode_1 this.currModeObj', this.currModeObj)

        if (this.currModeObj) {
          let i = this.currModeObj.tabTypeArr.indexOf(this.tabType)
          const dataKey = this.currModeObj.resultKeyArr[i]
          const data = dataKey ? this.datas[dataKey] : this.datas
          console.debug(
            'mode_1 this.currModeObj',
            this.datas,
            i,
            this.currModeObj.resultKeyArr[i],
            data
          )
          if (data.annotation) {
            this.annotationList = data.annotation
          }
          this.computedModeData(JSON.parse(JSON.stringify(data)))
        }
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    expandColumnCallback(tableColumnData) {
      let expandColumnData = []
      // 定义第一个展开行，宽度、字段值、class值
      const expand1RowFlexArr = [
        { flex: 0 },
        { flex: 0 },
        { flex: 2, prop: 'sportsName', className: 'sportsNameClass' },
        { flex: 1 },
        { flex: 1 },
        { flex: 1 },
        { flex: 1 },
        { flex: 1, prop: 'arrow', className: 'arrowIcon' },
        { flex: 0 },
      ]

      const expand2RowFlexArr = [
        { flex: 1 },
        { flex: 1 },
        { flex: 0 },
        { flex: 0 },
        { flex: 0 },
        { flex: 0 },
        {
          flex: 5,
          prop: 'medalType-playerName-matchName',
          className: 'medalType-playerName-matchNameClass',
        },
        { flex: 0 },
        { flex: 1, prop: 'zhanwei' },
      ]

      let mergeWidthPx = 0
      let mergeWidthVw = 0
      const expandRowFlexArr = [expand1RowFlexArr, expand2RowFlexArr]
      return expandRowFlexArr.map((expandRowFlexItem) => {
        let expandColumnData = []
        tableColumnData.forEach((columnItem, columnIndex) => {
          if (!expandRowFlexItem[columnIndex].flex) {
            mergeWidthPx += columnItem.widthPx - 0
            mergeWidthVw += columnItem.widthVw - 0
            console.debug('this.tableColumnData：', mergeWidthPx, mergeWidthVw)
          } else if (expandRowFlexItem[columnIndex].flex > 1) {
            mergeWidthPx += columnItem.widthPx - 0
            mergeWidthVw += columnItem.widthVw - 0
            expandColumnData.push({
              name: '合并',
              prop: expandRowFlexItem[columnIndex].prop, //sportsName,
              widthPx: mergeWidthPx,
              widthVw: mergeWidthVw,
              className: expandRowFlexItem[columnIndex].className,
            })
            mergeWidthPx = 0
            mergeWidthVw = 0
          } else {
            expandColumnData.push({
              name: columnItem.label,
              prop: columnItem.prop,
              widthPx: columnItem.widthPx,
              widthVw: columnItem.widthVw,
              className: columnItem.className,
            })
          }
        })
        return expandColumnData
      })
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length < 2) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        headColumns.push({
          colKey: 'arrowIcon',
          colTitle: '',
        })
        headColumns.push({
          colKey: 'isExpand',
          colTitle: '',
        })

        const otherColumns = headColumns
        this.defaultWidthVwNum = otherColumns.length - 2 //减去这2列[arrowIcon, isExpand]
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          const customColumn = {
            prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
            label: '运动员',
            // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnPlayerGroupClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            if (i == 2) {
              tableColumnData.push(customColumn)
            }
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? this.tableCellDefaultWidthVw / 2
                : 6.94, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? 'expandTdClassName'
                : '', //单独定制的头部样式class
              selected: '',
            })
          }

          this.tableColumnData = tableColumnData
        }
        const rowHeightVw = 2.778, //第一行 行高
          childRowHeightVw = 3.125, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
          childRowHeightOtherVw = 0.694 //0.694是表格最下面的留白

        const childRowBaseHeightVw = 3 * childRowHeightVw //第一行展开行的基础高度（固定的高度）
        this.tableData = data.data
          ? data.data.map((rowData) => {
              let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数
              let row_detail = []
              if (
                rowData.first_half_row_detail.data &&
                rowData.first_half_row_detail.data.length > 0
              ) {
                row_detail.push(rowData.first_half_row_detail)
                if (
                  rowData.first_half_row_detail.data.length > currDataListRowNum
                ) {
                  currDataListRowNum = rowData.first_half_row_detail.data.length
                }
              }
              if (
                rowData.second_half_row_detail.data &&
                rowData.second_half_row_detail.data.length > 0
              ) {
                row_detail.push(rowData.second_half_row_detail)
                if (
                  rowData.second_half_row_detail.data.length >
                  currDataListRowNum
                ) {
                  currDataListRowNum =
                    rowData.second_half_row_detail.data.length
                }
              }
              rowData.row_detail = row_detail
              rowData.arrowIcon = ''
              if (this.isExpandAll) {
                //是否全部展开
                rowData.isShowChild = true
              } else {
                rowData.isShowChild = false
              }
              if (rowData.row_detail && rowData.row_detail.length > 0) {
                rowData.isHasDetailData = true
              } else {
                rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                rowData.isHasDetailData = false
              }
              rowData.row_detail = rowData.row_detail ? rowData.row_detail : []

              rowData.isExpand = {
                rowHeightVw,
                currHeightVw:
                  childRowBaseHeightVw +
                  currDataListRowNum * childRowHeightVw +
                  childRowHeightOtherVw,
                list: rowData.row_detail,
              }
              return rowData
            })
          : []
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
    /* .compreSportsMeet_loadTree_table.eventComp_mode_1 {
      padding: 0;
    } */
  }
}
</style>
